import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { SocialProof } from '../components/home/SocialProof';
import { ProblemSolution } from '../components/home/ProblemSolution';
import { Ritual } from '../components/home/Ritual';
import { DaySeven } from '../components/home/DaySeven';
import { ViralRecap } from '../components/home/ViralRecap';
import { FAQ } from '../components/home/FAQ';
import { Button } from '../components/ui/Button';
export function Home() {
  return <Layout data-id="element-493">
      <Hero data-id="element-494" />
      <SocialProof data-id="element-495" />
      <ProblemSolution data-id="element-496" />
      <Ritual data-id="element-497" />
      <DaySeven data-id="element-498" />
      <ViralRecap data-id="element-499" />
      <FAQ data-id="element-500" />

      {/* Final CTA */}
      <section className="py-24 text-white text-center" style={{
      backgroundColor: '#ff6b6b'
    }} data-id="element-501">
        <div className="container mx-auto px-4" data-id="element-502">
          <h2 className="text-4xl md:text-6xl font-bold mb-8 tracking-tighter" data-id="element-503">
            Stop overthinking.
            <br data-id="element-504" />
            Start a FlingLink.
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-505">
            <a href="https://me.flinglink.app" data-id="element-506">
              <Button size="lg" variant="secondary" className="font-bold w-full sm:w-auto" style={{
              color: '#ff6b6b'
            }} data-id="element-507">
                Get Your FlingLink
              </Button>
            </a>
            <a href="https://me.flinglink.app/settings/upgrade" data-id="element-508">
              <Button size="lg" variant="outline" className="bg-transparent border-white text-white hover:bg-white/10 hover:text-white w-full sm:w-auto" data-id="element-509">
                Get Plus
              </Button>
            </a>
          </div>
        </div>
      </section>
    </Layout>;
}